/**
 * Customer-facing "Style №" code for a product.
 *
 * Since the product name became colour-free and code-free (see get-display-title),
 * the style code is the only stable identifier a shopper (or our in-store / bot
 * staff) can quote. It shows as "Style № <code>" on the PDP, in search, and on
 * every listing card.
 *
 * The code is the LEADING TOKEN of the first variant's SKU, before the size
 * suffix. The size format varies per product — "262017 (L)", "262015K-10/11",
 * "262003-S" — so we cut at the first size separator (space, "(", "-" or "/").
 * Codes are digits + an optional letter (e.g. "262015K") and never contain those
 * characters, so the leading non-separator run is the bare code. When no SKU is
 * loaded we fall back to the trailing code segment of the handle
 * ("superior-panjabi-262017" → "262017"), only when it looks like a code.
 *
 * Kept here (not in search.ts) so the PDP, search, and all card surfaces share
 * ONE extractor and never drift apart.
 */
type StyleProductLike = {
  variants?: ({ sku?: string | null } | null | undefined)[] | null
  handle?: string | null
} | null | undefined

export function getProductStyle(product: StyleProductLike): string | null {
  const sku = product?.variants?.[0]?.sku
  if (typeof sku === "string" && sku.trim()) {
    const code = sku.trim().match(/^[^\s(/-]+/)?.[0]
    if (code) return code.toUpperCase()
  }
  const tail = String(product?.handle || "").split("-").pop() || ""
  return /\d/.test(tail) ? tail.toUpperCase() : null
}
